import { bl_fi_einvoice_discrepancies_report_hdr_RowClass } from "../../dbschema/bl_fi_einvoice_discrepancies_report_hdr.model";
import { BaseContainerModel } from "../base-container.model";

export class EinvoiceDiscrepanciesReportHdrContainerModel extends BaseContainerModel {
    bl_fi_einvoice_discrepancies_report_hdr: bl_fi_einvoice_discrepancies_report_hdr_RowClass = new bl_fi_einvoice_discrepancies_report_hdr_RowClass();
}